/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class CallState {
    static STATUS_IDLE = 0;
    static STATUS_OUTGOING = 1;
    static STATUS_INCOMING = 2;
    static STATUS_CONNECTING = 3;
    static STATUS_CONNECTED = 4;
}
